import { useMutation } from '@tanstack/react-query';

import { verifyStripePayment } from '@/services/payment';
import { VerifyStripePaymentRequest } from '@/types/payment';

export function useVerifyStripePayment() {
  return useMutation({
    mutationFn: (data: VerifyStripePaymentRequest) => verifyStripePayment(data)
  });
}
